<ng-content select="[header]"></ng-content>

<ng-content select="[preview]"></ng-content>

<ng-content select="[drawer]"></ng-content>
<ng-content select="[pageDrawer]"></ng-content>
<ng-content select="[navigationDrawer]"></ng-content>
<ng-content select="[aiChatDrawer]"></ng-content>

<div class="constructor-container">
    <div class="panel-elements" *ngIf="!disableElementsPanel">
        <ng-content select="[elementsMenu]"></ng-content>
    </div>

    <div class="constructor-content">
        <ng-content select="[content]"></ng-content>
    </div>

    <div class="panel-options" *ngIf="!disableControlsPanel">
        <ng-content select="[controls]"></ng-content>
    </div>
</div>
